import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AppInitService } from '../../services/app-init.service';
import { SubjectSubscriber } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root',
})
export class SendWithinHeirarchyService {
  configurableFields = null;
  onSetConfigurableFields: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );
  constructor(private http: HttpClient, private appInitSerive: AppInitService) {
    if (!this.configurableFields) {
      if (!this.appInitSerive?.appConfig?.configurableFields) {
        this.configurableFields = this.appInitSerive?.appConfig?.configurableFields;
      } else {
        this.setConfigurableFields();
      }
    }
  }

  public setConfigurableFields(): void {
    this.appInitSerive?.getConfigurableFields()?.subscribe((res) => {
      this.configurableFields = this.appInitSerive?.appConfig?.configurableFields;
      this.onSetConfigurableFields.next(true);
    });
  }

  public sendWorkFlow(data): Observable<any> {
    let url = '/workflow/workflow-operation';
    return this.http.post(url, data);
  }
  public hierarchyDtls(params): Observable<any> {
    return this.http.get('/workflow/hierarchy-details', { params: params });
  }
}
